<template>
  <v-card>
    <v-card-title class="py-2 title">
      <v-icon class="mr-2">assignment</v-icon>
      <div class="title info--text">Information</div>
    </v-card-title>
    <v-divider></v-divider>
    <v-data-table :headers="headers" :items="items" disable-initial-sort hide-headers hide-actions class="elevation-1">
      <template v-slot:items="{ item, index}">
        <tr :class="{ alternate: index % 2 == 0 }">
          <td class="text-xs-left font-weight-medium">{{ item.Field}}</td>
          <td class="text-xs-left">{{item.FieldValue}}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
  import {
    calculateDisplayValue,
  } from '@/helpers/kvValueHelper'
  export default {
    props: {
      dataSource: {
        type: Object,
        required: true,
      },
      editForm: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      headers() {
        let headers = [{
          text: 'Field',
          value: 'Field',
        },
        {
          text: 'Value',
          value: 'Value',
        },
        ]
        // if (this.editForm) {
        //   headers.push({
        //     text: 'Actions',
        //     value: 'Actions'
        //   })
        // }
        return headers
      },
      items() {
        return [...this.plotInformation, ...this.plotMetadata]
      },
      plotInformation() {
        const data = [{
          Field: 'Data Type',
          FieldValue: 'Vegetative Data',
        },
        {
          Field: 'Plot Name',
          FieldValue: this.dataSource.PlotName,
        },
        {
          Field: 'Plot Type',
          FieldValue: this.dataSource.PlotType,
        },
        {
          Field: 'Community Type',
          FieldValue: this.dataSource.CommunityType,
        },
        ]
        return data
      },
      kvStore() {
        return this.dataSource.Metadata.Data
      },
      plotMetadata() {
        const data = Object.keys(this.kvStore).map(key => ({
          Field: key,
          FieldValue: calculateDisplayValue(this.kvStore[key]),
        }))
        return data
      },
    },
    methods: {

    },
  }
</script>